/**
 * @generated SignedSource<<08c4d09d711e240bee2a6040de5f8e23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersRosettaArticleContextArticle$data = {
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly name: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersRosettaArticleContextArticle";
};
export type helpersRosettaArticleContextArticle$key = {
  readonly " $data"?: helpersRosettaArticleContextArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersRosettaArticleContextArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersRosettaArticleContextArticle"
};

(node as any).hash = "75946644c66b357334c9d950def46df4";

export default node;
